import { type MotdRuleModel } from "./rules/models";

export type MotdPosition = "None" | "TopOfPage" | "UnderTopMenu";

export interface PageTag {
    tagName: string;
    value: string;
}

export interface IBannerBase {
    content: string;
    style: string;
    visibleFromUtc?: Date;
    visibleToUtc?: Date;
    isHtml: boolean;
    position: MotdPosition;
    specialImplementation: string;
}

export interface AdditionalBanner extends IBannerBase {
    key: string;
}

export interface MotdModel extends IBannerBase {
    id: number;
    ruleSets: MotdRuleModel[][];
}

export type BannerItem = MotdModel | AdditionalBanner;

export interface PositionPlaceholder {
    position: MotdPosition;
    items: BannerItem[];
}

export function matching(a: BannerItem, b: BannerItem) {
    if ("id" in a) {
        if ("id" in b) {
            return a.id == b.id;
        } else {
            return false;
        }
    }
    if ("key" in a) {
        if ("key" in b) {
            return a.key == b.key;
        } else {
            return false;
        }
    }
    return false;
}

export function getKey(item: BannerItem): string {
    if ("id" in item) return "motd_" + item.id;
    if ("key" in item) return item.key;
    console.warn("Unknown type. Using random number as key!");
    return Math.random().toString();
}

export function remove(motd: BannerItem, placeholder: PositionPlaceholder) {
    const item = placeholder.items.find((m: BannerItem) => matching(m, motd));
    if (item != null) {
        placeholder.items.splice(placeholder.items.indexOf(item), 1);
    }
}
